export const SHOW_NEWS_INDICATOR = 'SHOW_NEWS_INDICATOR'
export const HIDE_NEWS_INDICATOR = 'HIDE_NEWS_INDICATOR'

export const showNewsIndicator = () => ({
  type: SHOW_NEWS_INDICATOR
})

export const hideNewsIndicator = () => ({
  type: HIDE_NEWS_INDICATOR
})
